import {
  FETCH_ALL_COUNTRIES_SUCCESS,
  FETCH_SONGS_SUCCESS,
  CREATE_SONG_SUCCESS,
  RESTORE_CREATE_SONG_INITIAL,
  EDIT_SONG_SUCCESS,
  RESTORE_EDIT_SONG_INITIAL,
  DELETE_SONG_SUCCESS,
  RESTORE_DELETE_SONG_INITIAL,
  FETCH_SONG_BY_ID_SUCCESS,
  FETCH_ALL_BANNERS_SUCCESS,
  FETCH_BANNER_BY_ID_SUCCESS,
  CREATE_BANNER_SUCCESS,
  RESTORE_CREATE_BANNER_INITIAL,
  UPDATE_BANNER_SUCCESS,
  RESTORE_UPDATE_BANNER_INITIAL,
  DELETE_BANNER_SUCCESS,
  RESTORE_DELETE_BANNER_INITIAL,
  FETCH_ALL_PROMPT_SUCCESS,
  FETCH_PROMPT_BY_ID_SUCCESS,
  CREATE_PROMPT_SUCCESS,
  RESTORE_CREATE_PROMPT_INITIAL,
  UPDATE_PROMPT_SUCCESS,
  RESTORE_UPDATE_PROMPT_INITIAL,
  DELETE_PROMPT_SUCCESS,
  RESTORE_DELETE_PROMPT_INITIAL,
} from "../ActionTypes";

const INIT_STATE = {
  allCountries: [],
  allSongs: [],
  addSongSuccess: false,
  addSongFailure: false,
  editSongSuccess: false,
  editSongFailure: false,
  deleteSongSuccess: false,
  deleteSongFailure: false,
  songById: {},

  allBanners: [],
  bannerById: {},

  addBannerSuccess: false,
  addBannerFailure: false,

  editBannerSuccess: false,
  editBannerFailure: false,

  deleteBannerSuccess: false,
  deleteBannerFailure: false,

  allPrompts: [],
  promptById: {},

  addPromptSuccess: false,
  addPromptFailure: false,

  editPromptSuccess: false,
  editPromptFailure: false,

  deletePromptSuccess: false,
  deletePromptFailure: false,
};

const miscReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_ALL_COUNTRIES_SUCCESS: {
      return {
        ...state,
        allCountries: action.payload,
      };
    }

    case FETCH_SONGS_SUCCESS: {
      return {
        ...state,
        allSongs: action.payload,
      };
    }

    case FETCH_SONG_BY_ID_SUCCESS: {
      return {
        ...state,
        songById: action.payload,
      };
    }

    case CREATE_SONG_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          addSongSuccess: true,
          addSongFailure: false,
        };
      } else {
        return {
          ...state,
          addSongSuccess: false,
          addSongFailure: true,
        };
      }
    }

    case RESTORE_CREATE_SONG_INITIAL: {
      return {
        ...state,
        addSongSuccess: false,
        addSongFailure: false,
      };
    }

    case EDIT_SONG_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          editSongSuccess: true,
          editSongFailure: false,
        };
      } else {
        return {
          ...state,
          editSongSuccess: false,
          editSongFailure: true,
        };
      }
    }

    case RESTORE_EDIT_SONG_INITIAL: {
      return {
        ...state,
        editSongSuccess: false,
        editSongFailure: false,
      };
    }

    case DELETE_SONG_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          deleteSongSuccess: true,
          deleteSongFailure: false,
        };
      } else {
        return {
          ...state,
          deleteSongSuccess: false,
          deleteSongFailure: true,
        };
      }
    }

    case RESTORE_DELETE_SONG_INITIAL: {
      return {
        ...state,
        deleteSongSuccess: false,
        deleteSongFailure: false,
      };
    }

    case FETCH_ALL_BANNERS_SUCCESS: {
      return {
        ...state,
        allBanners: action.payload,
      };
    }

    case FETCH_BANNER_BY_ID_SUCCESS: {
      return {
        ...state,
        bannerById: action.payload,
      };
    }

    case CREATE_BANNER_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          addBannerSuccess: true,
          addBannerFailure: false,
        };
      } else {
        return {
          ...state,
          addBannerSuccess: false,
          addBannerFailure: true,
        };
      }
    }

    case RESTORE_CREATE_BANNER_INITIAL: {
      return {
        ...state,
        addBannerSuccess: false,
        addBannerFailure: false,
      };
    }

    case UPDATE_BANNER_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          editBannerSuccess: true,
          editBannerFailure: false,
        };
      } else {
        return {
          ...state,
          editBannerSuccess: false,
          editBannerFailure: true,
        };
      }
    }

    case RESTORE_UPDATE_BANNER_INITIAL: {
      return {
        ...state,
        editBannerSuccess: false,
        editBannerFailure: false,
      };
    }

    case DELETE_BANNER_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          deleteBannerSuccess: true,
          deleteBannerFailure: false,
        };
      } else {
        return {
          ...state,
          deleteBannerSuccess: false,
          deleteBannerFailure: true,
        };
      }
    }

    case RESTORE_DELETE_BANNER_INITIAL: {
      return {
        ...state,
        deleteBannerSuccess: false,
        deleteBannerFailure: false,
      };
    }

    case FETCH_ALL_PROMPT_SUCCESS: {
      return {
        ...state,
        allPrompts: action.payload,
      };
    }

    case FETCH_PROMPT_BY_ID_SUCCESS: {
      return {
        ...state,
        promptById: action.payload,
      };
    }

    case CREATE_PROMPT_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          addPromptSuccess: true,
          addPromptFailure: false,
        };
      } else {
        return {
          ...state,
          addPromptSuccess: false,
          addPromptFailure: true,
        };
      }
    }

    case RESTORE_CREATE_PROMPT_INITIAL: {
      return {
        ...state,
        addPromptSuccess: false,
        addPromptFailure: false,
      };
    }

    case UPDATE_PROMPT_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          editPromptSuccess: true,
          editPromptFailure: false,
        };
      } else {
        return {
          ...state,
          editPromptSuccess: false,
          editPromptFailure: true,
        };
      }
    }

    case RESTORE_UPDATE_PROMPT_INITIAL: {
      return {
        ...state,
        editPromptSuccess: false,
        editPromptFailure: false,
      };
    }

    case DELETE_PROMPT_SUCCESS: {
      if (action.payload === true) {
        return {
          ...state,
          deletePromptSuccess: true,
          deletePromptFailure: false,
        };
      } else {
        return {
          ...state,
          deletePromptSuccess: false,
          deletePromptFailure: true,
        };
      }
    }

    case RESTORE_DELETE_PROMPT_INITIAL: {
      return {
        ...state,
        deletePromptSuccess: false,
        deletePromptFailure: false,
      };
    }

    default:
      return state;
  }
};

export default miscReducer;
